import { contents } from '../../data/contents';
import { useUserEvent, useUserEventLegacy } from '../../services/queries/chatbotQueries';
import listStyles from '../../style/styles/Display.module.css';
import styles from '../../style/styles/ProductView.module.css';
import { redirectToPage, sendAddProductToCart } from '../../utils/utils';
import { useUserStore, useChatStateStore, useToastStore, useChatbotStore } from '../../zustand/store';
import { ProductInfoTypeVertical, ProductInfoTypeHorizontal } from './ProductInfoType';
import { useNavigate } from 'react-router-dom';
import { postCafe24ProductStockCheck } from '../../utils/apis'

export const CarouselListVertical = (props) => {
    const { products, idx } = props;
    const { isMobileDevice, partnerType, chatUserId, partnerId } = useUserStore();
    const { mutate: postUserEventLegacy } = useUserEventLegacy();
    const { mutate: postUserEvent } = useUserEvent();
    const { isConsole, isNewProduct, addToCartWithOption } = useChatStateStore();
    const { chatbot } = useChatbotStore();
    const { setToastMessage, setIsToastVisible } = useToastStore();
    const productInfoType = partnerType === 'fastfive' ? 1 : 0;
    const showCartCta = partnerType === 'cafe24';
    const navigate = useNavigate();

    return (
        <div key={idx} className={`${listStyles.ProductListVertical__productList} carousel-card ${isNewProduct && listStyles.bounce}`}>
            {products.map((product, productIdx) => (
                <div 
                    key={productIdx} 
                    className={listStyles.ProductListVertical__productItem}
                    style={{cursor: product?.productUrl && product?.productUrl.length > 0 ? 'pointer' : 'default'}}
                    onClick={() => {
                        if (product?.productUrl && product?.productUrl.length > 0) {
                            redirectToPage(
                                product?.productUrl, 
                                isConsole,
                                isMobileDevice
                            );
                            postUserEventLegacy({
                                eventCategory: 'CarouselClicked',
                                product: product,
                            });
                        }
                    }}
                >
                    <div className={listStyles.ProductListVertical__productImageWrapper}>
                        <img 
                            className={listStyles.ProductListVertical__productImage} 
                            src={product.imageUrl} 
                            alt={product.name} 
                        />
                        {
                            showCartCta &&
                            <div 
                                className={styles.CartButton__sizeM}
                                style={{position: 'absolute', top: '4px', right: '4px'}}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    processAddToCartCtaClicked({
                                        product,
                                        partnerId,
                                        isConsole,
                                        isMobileDevice,
                                        setToastMessage,
                                        setIsToastVisible,
                                        addToCartWithOption,
                                        chatbot,
                                        chatUserId,
                                        navigate,
                                        postUserEventLegacy,
                                        postUserEvent,
                                        sendAddProductToCart,
                                        redirectToPage,
                                    });
                                }}
                            >
                                <img src='/img/units/carousel-cart.png' width={18} height={18} alt='cart' />
                            </div>
                        }
                    </div>
                    <div className='spacing-2'/>
                    <ProductInfoTypeVertical product={product} type={productInfoType} />
                </div>
            ))}
        </div>
    )
}

export const CarouselListHorizontal = (props) => {
    const { products, idx } = props;
    const { isMobileDevice, partnerType, chatUserId, partnerId } = useUserStore();
    const { chatbot } = useChatbotStore();
    const { isConsole, isNewProduct, addToCartWithOption } = useChatStateStore();
    const { mutate: postUserEventLegacy } = useUserEventLegacy();
    const { mutate: postUserEvent } = useUserEvent();
    const { setToastMessage, setIsToastVisible } = useToastStore();
    const showCartCta = partnerType === 'cafe24'
    const productInfoType = 0;  // default
    const navigate = useNavigate();

    return (
        <div key={idx} className={`${listStyles.ProductListHorizontal__productList} carousel-card ${isNewProduct && listStyles.bounce}`}>
            {products.map((product, productIdx) => (
                <div 
                    key={productIdx} 
                    className={listStyles.ProductListHorizontal__productItem}
                    style={{cursor: product?.productUrl && product?.productUrl.length > 0 ? 'pointer' : 'default'}}
                    onClick={() => {
                        if (product?.productUrl && product?.productUrl.length > 0) {
                            redirectToPage(
                                product?.productUrl, 
                                isConsole,
                                isMobileDevice
                            );
                            postUserEventLegacy({
                                eventCategory: 'CarouselClicked',
                                product: product,
                            });
                        }
                    }}
                >
                    <div style={{display: 'flex', alignItems: 'center', width: '100%'}}>
                        <div className={listStyles.ProductListHorizontal__productImageWrapper}>
                            <img 
                                className={listStyles.ProductListHorizontal__productImage} 
                                src={product.imageUrl} 
                                alt={product.name} 
                            />
                        </div>
                        <div className='spacing-12'/>
                        <ProductInfoTypeHorizontal product={product} type={productInfoType} />
                    </div>
                    {
                        showCartCta &&
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <div className='spacing-20'/>
                            <div 
                                className={styles.CartButton__sizeM}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    processAddToCartCtaClicked({
                                        product,
                                        partnerId,
                                        isConsole,
                                        isMobileDevice,
                                        setToastMessage,
                                        setIsToastVisible,
                                        addToCartWithOption,
                                        chatbot,
                                        chatUserId,
                                        navigate,
                                        postUserEventLegacy,
                                        postUserEvent,
                                        sendAddProductToCart,
                                        redirectToPage,
                                    });
                                }}
                            >
                                <img src='/img/units/carousel-cart.png' width={18} height={18} alt='cart' />
                            </div>
                        </div>
                    }
                </div>
            ))}
        </div>
    )
    
}


export const CarouselSingle = (props) => {
    const { products } = props;
    const { isMobileDevice, partnerType, chatUserId, partnerId } = useUserStore();
    const { isConsole, isNewProduct, language, addToCartWithOption } = useChatStateStore();
    const { mutate: postUserEventLegacy } = useUserEventLegacy();
    const { mutate: postUserEvent } = useUserEvent();
    const { setToastMessage, setIsToastVisible } = useToastStore();
    const showCartCta = partnerType === 'cafe24'
    const navigate = useNavigate();
    const { chatbot } = useChatbotStore();

    return (
        products.map((product, idx) => {
            return (
                <div 
                    className={`${styles.ProductCard} ${!isMobileDevice && styles.ExtraPadding__horizontal} carousel-card ${isNewProduct && listStyles.bounce}`} 
                    key={idx}
                    onClick={() => {
                        redirectToPage(
                            product?.productUrl, 
                            isConsole,
                            isMobileDevice
                        );
                        postUserEventLegacy({
                            eventCategory: 'CarouselClicked',
                            product: product,
                        });
                    }}
                >
                    <img
                        src={product?.imageUrl}
                        alt={product?.name}
                        className={styles.ProductCard__productImage}
                    />
                    <div className='spacing-16' />
                    <div className={styles.ProductCard__productInfo}>
                        <div className={styles.ProductCard__productName}>{product?.name}</div>
                        <div className='spacing-4' />
                        {
                            chatbot?.isCarouselPriceVisible ?
                            <div className={styles.ProductCard__priceWrapper}>
                                {
                                    product?.discount > 0 &&
                                    <>
                                        <div className={styles.ProductCard__discountRate}>{product?.discount?.toLocaleString()}%</div>
                                        <div className='spacing-2' />
                                    </>
                                }
                                <div className={styles.ProductCard__productPrice}>{contents.carousel[language].priceUnit}{product?.price?.toLocaleString()}</div>
                            </div> :
                            <div className='spacing-16' />

                        }
                        <div className='spacing-4' />
                        <div className={styles.ProductCard__reviewWrapper}>
                            {
                                product?.rate > 0 ?
                                    <>
                                        <img src='/img/units/star-gray-300.png' width={14} height={14} alt='star' />
                                        <div className='spacing-2' />
                                        <p className={styles.ProductCard__reviewScore}>{product?.rate.toFixed(1)}</p>
                                        <div className='spacing-4' />
                                        <p className={styles.ProductCard__reviewScore}>{contents.carousel[language].review}{' '}{product?.reviewNum}</p>
                                    </> :
                                    <>
                                        <img src='/img/units/star-gray-300.png' width={14} height={14} alt='star' />
                                        <div className='spacing-2' />
                                        <p className={styles.ProductCard__reviewScore}>{contents.carousel[language].new}</p>
                                    </>
                            }
                        </div>
                        <div className='spacing-4' />
                        {
                            showCartCta ?
                            <div 
                                className={styles.ProductCard__detailButton}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    processAddToCartCtaClicked({
                                        product,
                                        partnerId,
                                        isConsole,
                                        isMobileDevice,
                                        setToastMessage,
                                        setIsToastVisible,
                                        addToCartWithOption,
                                        chatbot,
                                        chatUserId,
                                        navigate,
                                        postUserEventLegacy,
                                        postUserEvent,
                                        sendAddProductToCart,
                                        redirectToPage,
                                    });
                                }}
                            >
                                <img src='/img/units/carousel-cart.png' width={16} height={16} alt='cart' />
                                <div className='spacing-4' />
                                <p 
                                    className={styles.ProductCard__detailButtonText}
                                >담기</p>
                            </div>
                            :
                            <div 
                                className={styles.ProductCard__detailButton}
                            >
                                <p 
                                    className={styles.ProductCard__detailButtonText}
                                >자세히 보기</p>
                            </div>
                        }
                    </div>
                </div>
            )
        })
    )
}

export const CarouselListVerticalModal = (props) => {
    const { products, idx } = props;
    const { isMobileDevice, partnerType, chatUserId, partnerId } = useUserStore();
    const { chatbot } = useChatbotStore();
    const { mutate: postUserEventLegacy } = useUserEventLegacy();
    const { mutate: postUserEvent } = useUserEvent();
    const { isConsole, isNewProduct, addToCartWithOption } = useChatStateStore();
    const { setToastMessage, setIsToastVisible } = useToastStore();
    const productInfoType = partnerType === 'fastfive' ? 1 : 0;
    const showCartCta = partnerType === 'cafe24';
    const navigate = useNavigate();

    return (
        <div key={idx} className={`${listStyles.ProductListVertical__productList} carousel-card ${isNewProduct && listStyles.bounce}`}>
            {products.map((product, productIdx) => (
                <div 
                    key={productIdx} 
                    className={listStyles.ProductListVertical__productItem}
                    style={{cursor: product?.productUrl && product?.productUrl.length > 0 ? 'pointer' : 'default'}}
                    onClick={() => {
                        if (product?.productUrl && product?.productUrl.length > 0) {
                            redirectToPage(
                                product?.productUrl, 
                                isConsole,
                                isMobileDevice
                            );
                            postUserEventLegacy({
                                eventCategory: 'CarouselClicked',
                                product: product,
                            });
                        }
                    }}
                >
                    <div className={listStyles.ProductListVertical__productImageWrapper}>
                        <img 
                            className={listStyles.ProductListVertical__productImage} 
                            src={product.imageUrl} 
                            alt={product.name} 
                        />
                        {
                            showCartCta &&
                            <div 
                                className={styles.CartButton__sizeM}
                                style={{position: 'absolute', top: '4px', right: '4px'}}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    processAddToCartCtaClicked({
                                        product,
                                        partnerId,
                                        isConsole,
                                        isMobileDevice,
                                        setToastMessage,
                                        setIsToastVisible,
                                        addToCartWithOption,
                                        chatbot,
                                        chatUserId,
                                        navigate,
                                        postUserEventLegacy,
                                        postUserEvent,
                                        sendAddProductToCart,
                                        redirectToPage,
                                    });
                                }}
                            >
                                <img src='/img/units/carousel-cart.png' width={18} height={18} alt='cart' />
                            </div>
                        }
                    </div>
                    <div className='spacing-2'/>
                    <ProductInfoTypeVertical product={product} type={productInfoType} />
                </div>
            ))}
        </div>
    )
}

const processAddToCartCtaClicked = async (props) => {
    const { 
        product, 
        partnerId,
        isConsole, 
        isMobileDevice, 
        setToastMessage, 
        setIsToastVisible,
        addToCartWithOption,
        chatbot,
        chatUserId,
        navigate,
        postUserEventLegacy,
        postUserEvent,
        sendAddProductToCart,
        redirectToPage,
    } = props;

    const isProductSelling = await postCafe24ProductStockCheck(partnerId, product.itemId);
    if (isProductSelling?.selling === "F") {
        setToastMessage('품절된 상품입니다');
        setIsToastVisible(true);
        return;
    }
    // 세트 상품 edge case cjfl
    if (product?.isSet === 'T') {
        setToastMessage('세트 상품은 직접 담아주세요');
        setIsToastVisible(true);
        
        redirectToPage(
            product?.productUrl, 
            isConsole,
            isMobileDevice
        );
        postUserEventLegacy({
            eventCategory: 'CarouselClicked',
            product: product,
        });
        return;
    }
    const gentooStatics = JSON.parse(sessionStorage.getItem('gentoo-statics'));
    postUserEvent({
        payload: {
            ...gentooStatics,
            timestamp: String(Date.now()),
            eventCategory: 'chat_add_to_cart_started',
            context: {
                productId: product.itemId,
                requiredOption: product?.hasRequiredOption === 'T',
            }
        },
    });
    if (addToCartWithOption) {  // FlowLift C
        if (product?.hasOption === 'T' || (product?.variantList ?? []).length > 1) {
            sessionStorage.setItem('product-option', JSON.stringify(product));
            navigate(`/chat/${chatbot.chatbotId}/${chatUserId}/${product.itemId}`);
        } else if (product?.hasOption === 'F') {  
            sendAddProductToCart(product, isConsole, isMobileDevice, setToastMessage, setIsToastVisible);
            postUserEventLegacy({
                eventCategory: 'AddToCartCarousel',
                product: product,
            });
        } else { // fall back
            console.warn('variantList of product is empty');
            setToastMessage('이 상품은 직접 담아주세요');	// 추후 수정 필요
            setIsToastVisible(true);

            redirectToPage(
                product?.productUrl, 
                isConsole,
                isMobileDevice
            );
            postUserEventLegacy({
                eventCategory: 'CarouselClicked',
                product: product,
            });
            return;
        } 
    } else {                    // FlowLift B
        sendAddProductToCart(product, isConsole, isMobileDevice, setToastMessage, setIsToastVisible);
        postUserEventLegacy({
            eventCategory: 'AddToCartCarousel',
            product: product,
        });
    }
}